(function() {
  var BaseStep,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseStep = App.loadClass("grower::viewmodels/fields/add/steps/BaseStep");

  exports.SaveField = (function(superClass) {
    extend(SaveField, superClass);

    function SaveField() {
      this._saveZonesComplete = bind(this._saveZonesComplete, this);
      this._handleResult = bind(this._handleResult, this);
      this._saveComplete = bind(this._saveComplete, this);
      return SaveField.__super__.constructor.apply(this, arguments);
    }

    SaveField.prototype.beforeSet = function() {
      this.saveStatus = ko.observable();
      this.saveErrors = ko.observableArray();
      this.zoneStatus = ko.observable("");
      return this.canGoBack = ko.observable(false);
    };

    SaveField.prototype.afterSet = function() {
      this.parent.currentField().hideGeometry();
      this.saveStatus("Saving...");
      return this.parent.currentField().save(this._saveComplete);
    };

    SaveField.prototype._saveComplete = function(result) {
      this.saveErrors([]);
      if ((result != null ? result.status : void 0) == null) {
        this.saveStatus(result);
        return;
      }
      return this._handleResult(result, this.saveStatus, (function(_this) {
        return function(result) {
          if (_this.parent.currentField().id != null) {
            _this.saveStatus("Field updated successfully");
          } else {
            _this.parent.currentField().id = result.data.id;
            _this.saveStatus("Field Saved successfully");
          }
          if (_this.parent.anyManagementZonesSelected()) {
            _this.zoneStatus("Saving your permanent zones...");
            _this.parent.zoneManager.setFieldsId(_this.parent.currentField().id);
            return _this.parent.zoneManager.save(_this._saveZonesComplete);
          } else {
            return _this["continue"]();
          }
        };
      })(this));
    };

    SaveField.prototype._handleResult = function(result, statusvar, success, error) {
      var ref;
      this.saveErrors([]);
      if ((result != null ? result.status : void 0) == null) {
        statusvar(result);
        this.canGoBack(true);
        return;
      }
      if (result.status.type === "success") {
        this.canGoBack(false);
        return success(result);
      } else {
        this.canGoBack(true);
        statusvar(result.status.msg);
        if (((ref = result.data) != null ? ref.errors : void 0) != null) {
          this.saveErrors(result.data.errors);
        }
        if ($.isFunction(error)) {
          return error();
        }
      }
    };

    SaveField.prototype._saveZonesComplete = function(result) {
      var count, i, j, len, oldstat, status, success;
      count = 0;
      success = 0;
      status = ko.observable("");
      for (j = 0, len = result.length; j < len; j++) {
        i = result[j];
        count++;
        oldstat = status();
        this._handleResult(i.result, status, (function(_this) {
          return function(r) {
            var name;
            success++;
            name = i.zone_type;
            return status("<br />" + name + " zones saved successfully");
          };
        })(this));
        status(oldstat + status());
      }
      this.zoneStatus(status());
      if (success === count) {
        return this["continue"]();
      } else {
        return this.canGoBack(true);
      }
    };

    SaveField.prototype["continue"] = function() {
      var dlg;
      this.canGoBack(false);
      dlg = this.parent.handler.createSubHandler("grower::handlers/fields/dialogs/FieldDetailsDialog");
      if (dlg) {
        dlg.modalOptions = {
          backdrop: 'static'
        };
        dlg.loadLayoutPostOptions = {
          id: this.parent.currentField().id
        };
        dlg.refreshNavHandler = false;
        dlg.afterHidden = (function(_this) {
          return function() {
            dlg.destroy();
            return _this.parent.changeStep("wantAddMoreFields");
          };
        })(this);
        return dlg.init();
      }
    };

    return SaveField;

  })(BaseStep);

}).call(this);
